export const cleanNumericValue = (val) => {
  if (val === undefined || val === null || val === "") return "";

  // Jika sudah berupa number (dari Excel), ubah ke string
  let strVal = String(val).trim();

  // Cek apakah ini formula (mengandung huruf selain 'e' untuk scientific, atau operator)
  // Kita anggap angka murni jika hanya berisi digit, titik, dan koma
  const isPotentialNumber = /^[0-9.,]+$/.test(strVal);

  if (isPotentialNumber) {
    // Logika pembersihan:
    // 1. Jika ada koma DAN titik (misal 1,200.50), hapus koma, biarkan titik desimal
    // 2. Jika hanya ada koma (misal 1,200), hapus koma
    // 3. Kita standarkan ke format database: tanpa pemisah ribuan, titik untuk desimal

    if (strVal.includes(",") && strVal.includes(".")) {
      strVal = strVal.replace(/,/g, ""); // Format US: 1,000.00 -> 1000.00
    } else if (strVal.includes(",")) {
      // Cek jika koma berfungsi sebagai ribuan (ID) atau desimal (EU)
      // Sederhananya, kita hapus koma jika itu ribuan
      strVal = strVal.replace(/,/g, "");
    }

    // Hapus semua titik ribuan, tapi sisakan SATU titik terakhir jika itu desimal
    const parts = strVal.split(".");
    if (parts.length > 2) {
      // Kasus 1.000.000 -> 1000000
      return strVal.replace(/\./g, "");
    }
    return strVal;
  }

  return strVal; // Formula
};

export const formatDisplayNumber = (val) => {
  if (!val) return "";
  const strVal = String(val).replace(/\./g, ""); // Bersihkan dulu titik yang ada
  if (/^\d+$/.test(strVal)) {
    // Format jadi ribuan: 1000000 -> 1.000.000
    return strVal.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }
  return val; // Jika formula, jangan di-format
};
